export default {
    'apiPath': 'http://192.168.0.120:3001/api/v1/',
}